/**
 * Chuỗi dùng chung của module `rpa` (Quản lý RPA, ADR-0103) và màn Cấu hình lỗi & kết nối — tạm tách tệp khi dựng
 * song song, sẽ gộp vào `vi.ts`. Câu chữ lấy từ namespace `rpa.*` của web-portal native, đổi sang kiểu dấu thanh mới.
 */
export const viRpaChung = {
  rpa: {
    nhom: 'Quản lý RPA',
    khongCoQuyenTieuDe: 'Bạn chưa được xem màn này',
    khongCoQuyenMoTa: 'Cần quyền {{quyen}}. Nhờ quản trị tổ chức cấp quyền nếu bạn cần dùng màn này.',
    chuaKhaiTieuDe: 'Chưa kết nối OpenCore',
    moKetNoi: 'Mở Kết nối OpenCore',
    nhoQuanTri: 'Nhờ người có quyền cấu hình kết nối OpenCore khai địa chỉ và JWT dịch vụ của tổ chức.',
    chuaSanSangTieuDe: 'Module Quản lý RPA chưa sẵn sàng',
    chuaSanSangMoTa: 'Máy chủ chưa chạy module này. Thử lại sau ít phút, lỗi còn lặp lại thì báo đội vận hành.',
    loiTai: 'Không tải được dữ liệu RPA',
    dangBat: 'Đang bật',
    dangTat: 'Đang tắt',
  },
  rpaCauHinh: {
    tieuDe: 'Cấu hình lỗi & thông báo',
    moTa: 'Đặt cách Robot xử lý từng loại lỗi, cách máy chủ báo tin (chọn theo Project) và kết nối OpenCore của tổ chức.',
    tabLoi: 'Cấu hình lỗi',
    tabThongBao: 'Cấu hình thông báo',
    tabTaiKhoanGui: 'Tài khoản gửi',
    tabKetNoi: 'Kết nối OpenCore',
  },
} as const;
